module.exports = __webpack_public_path__ + "src/assets/games/9/174.jpg";